import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'mzic-privacy-pt-br',
  imports: [CommonModule],
  templateUrl: './privacy-pt-br.component.html',
  styleUrl: './styles.scss',
})
export class PrivacyPtBrComponent {}
